var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"max-container"},[_c('v-row',{staticClass:"flex-row-center"},[_c('div',[_c('v-img',{staticClass:"div__emptyimg",attrs:{"src":require("@/assets/empty-views/empty_indicate.svg")}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }